import React from 'react';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import LazyLearnMoreModal from '../../FreelancerPage/LearnMoreModal/LazyLearnMoreModal';

/** @type {React.FC<{className?: string;}>} */
export const LearnMoreButton = ({ className }) => (
    <LazyLearnMoreModal>
        <Button className={className} variant="outline" intent="secondary">
            <I18n k="freelancer_page.about.learn_more" />
        </Button>
    </LazyLearnMoreModal>
);
